var _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRssThumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#A161F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69778 13.2382C8.42103 13.2382 8.15561 13.3482 7.95992 13.5439C7.76423 13.7396 7.6543 14.005 7.6543 14.2817C7.6543 14.5585 7.76423 14.8239 7.95992 15.0196C8.15561 15.2153 8.42103 15.3252 8.69778 15.3252C9.72513 15.2938 10.7484 15.4679 11.7076 15.8372C12.6668 16.2065 13.5426 16.7636 14.2837 17.4758C15.0248 18.188 15.6162 19.041 16.0234 19.9847C16.4305 20.9285 16.6451 21.944 16.6546 22.9718C16.6546 23.2485 16.7646 23.514 16.9603 23.7096C17.156 23.9053 17.4214 24.0153 17.6981 24.0153C17.9749 24.0153 18.2403 23.9053 18.436 23.7096C18.6317 23.514 18.7416 23.2485 18.7416 22.9718C18.7349 21.6692 18.4683 20.381 17.9573 19.1827C17.4463 17.9845 16.7012 16.9003 15.7657 15.9937C14.8303 15.0872 13.7233 14.3765 12.5096 13.9033C11.2959 13.4302 9.99998 13.2041 8.69778 13.2382Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71926 7.65216C8.44251 7.65216 8.1771 7.7621 7.98141 7.95779C7.78572 8.15348 7.67578 8.41889 7.67578 8.69564C7.67578 8.97239 7.78572 9.2378 7.98141 9.43349C8.1771 9.62918 8.44251 9.73912 8.71926 9.73912C16.3137 9.73912 22.2629 15.5513 22.2629 22.9718C22.2629 23.2486 22.3729 23.514 22.5685 23.7097C22.7642 23.9054 23.0296 24.0153 23.3064 24.0153C23.5831 24.0153 23.8486 23.9054 24.0442 23.7097C24.2399 23.514 24.3499 23.2486 24.3499 22.9718C24.3499 14.3812 17.4838 7.65216 8.71926 7.65216Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0891 24.0076C11.4338 24.0076 12.5239 22.9175 12.5239 21.5728C12.5239 20.2282 11.4338 19.1381 10.0891 19.1381C8.74439 19.1381 7.6543 20.2282 7.6543 21.5728C7.6543 22.9175 8.74439 24.0076 10.0891 24.0076Z",
    fill: "white"
  })));
}

export default SvgRssThumb;